<!-- Quick View Panel Code  -->
 @if(brokerMappingService.isView){
<p-drawer id="sidebar_brokermapping_view" styleClass="u ui-sidebar-lg"
  [style]="{ 'width': 'auto', 'max-width': '580px', 'height': 'auto', 'overflow-y': 'auto', 'max-height': '100%'}"
  [(visible)]="brokerMappingService.isView" position="right" (onHide)="onClose()" showEffect="fade" appendTo="body" focusOnShow="false">
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div>
      <h3 class="ui-grid-col-12">View Broker Details </h3>
      @for (col of columns; track col;){
      <div class="ui-grid-col-12">
        @if(col.header!='Action'){
        <span>
          <div class="ui-grid-col-5 quick-view-grid-row">
            <label for="colHeader">{{col.header}}</label>
          </div>
          <div lass="ui-grid-col-7 quick-view-grid-row">
            <input pInputText [id]="col.field" [value]="selectedRow[col.field]" [disabled]="true" />
          </div>
        </span>}
      </div>}
    </div>
  </div>
</p-drawer>}